/* Perde Koli: phone & tablet behaviour. */
(function () {
  'use strict';
  var root = document.documentElement;

  /* Drop-down menu: light header while open, close on Escape. */
  var btn = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (btn && menu) {
    var sync = function () { root.classList.toggle('pk-menu-open', btn.getAttribute('aria-expanded') === 'true'); };
    new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['aria-expanded'] });
    /* Close with a smooth roll-up instead of disappearing at once. */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.addEventListener('click', function (e) {
      if (!e.target.closest || e.target.closest('[data-menu-toggle]') !== btn) return;
      if (btn.getAttribute('aria-expanded') !== 'true' || reduce.matches) return;
      e.stopImmediatePropagation(); e.preventDefault();
      if (menu.classList.contains('is-closing')) return;
      menu.classList.add('is-closing');
      setTimeout(function () {
        menu.hidden = true;
        menu.classList.remove('is-closing');
        btn.setAttribute('aria-expanded', 'false');
      }, 400);
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { btn.click(); btn.focus(); }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1100 && btn.getAttribute('aria-expanded') === 'true') btn.click();
    });
  }

  /* Materials: swipe the polaroid pile left/right to browse. */
  document.querySelectorAll('[data-materials]').forEach(function (section) {
    var stack = section.querySelector('[data-stack]');
    var next = section.querySelector('[data-step="1"]');
    var prev = section.querySelector('[data-step="-1"]');
    if (!stack || !next || !prev) return;
    if (window.matchMedia('(hover: none)').matches && !section.querySelector('.materials__swipe')) {
      var hint = document.createElement('p');
      hint.className = 'materials__swipe';
      hint.textContent = document.documentElement.lang.indexOf('sq') === 0 ? 'Rrëshqit ose prek për të shfletuar' : 'Swipe or tap to browse';
      stack.insertAdjacentElement('afterend', hint);
    }
    var x0 = null, y0 = null, t0 = 0, swiped = false;
    stack.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; t0 = Date.now(); swiped = false;
    }, { passive: true });
    stack.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3 && Date.now() - t0 < 800) {
        swiped = true;
        (dx < 0 ? next : prev).click();
      }
      x0 = null;
    }, { passive: true });
    /* A swipe should not also count as a tap on the pile. */
    stack.addEventListener('click', function (e) {
      if (swiped) { e.stopImmediatePropagation(); e.preventDefault(); swiped = false; }
    }, true);
  });
})();
